import React, { Component, Fragment } from "react";
import ReactGA from "react-ga";
import PreguntasComponent from "../componentes/preguntas";
import NavBarComponent from "../../utilerias/nav";
import MenuComponent from "../../utilerias/menu";
import PreguntasF from "../../utilerias/español/preguntasF.json";
import PreguntasEN from "../../utilerias/ingles/preguntasEN.json";
import EncabezadoComponent from "../../utilerias/encabezado";
import RedesComponent from "../../utilerias/redesSociales";
import $ from "jquery";
import "./styles.css";

export class Preguntas extends Component {
  constructor(props) {
    super(props);
    this.contenedorPreguntas = this.contenedorPreguntas.bind(this);
    this.abrirRespuesta = this.abrirRespuesta.bind(this);
    this.state = {
      guardarIdioma: "",
      guardarNuevoIdioma: true,
      idiomaNavegador: navigator.language || navigator.userLanguage,
      componente: "",
      statusMenu: false,
    };
  }

  UNSAFE_componentWillMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        this.setState({ guardarIdioma: PreguntasEN });
        this.setState({ componente: "frequently asked questions" });
        this.setState({ guardarNuevoIdioma: false });
      } else {
        this.setState({ guardarIdioma: PreguntasF });
        this.setState({ componente: "preguntas frecuentes" });
        this.setState({ guardarNuevoIdioma: true });
      }
    } else {
      if (storage !== null && storage === false) {
        this.setState({ guardarIdioma: PreguntasF });
        this.setState({ componente: "preguntas frecuentes" });
        this.setState({ guardarNuevoIdioma: true });
      } else {
        this.setState({ guardarIdioma: PreguntasEN });
        this.setState({ componente: "frequently asked questions" });
        this.setState({ guardarNuevoIdioma: false });
      }
    }
  }

  componentDidMount() {
    this.contenedorPreguntas();
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    } else {
      if (storage !== null && storage === false) {
        document.getElementById("text-lang").innerHTML = "ESP";
      } else {
        document.getElementById("text-lang").innerHTML = "ENG";
      }
    }
  }

  abrirRespuesta(id) {
    const respuesta = document.getElementById("respuesta-" + id);

    if (respuesta.style.height === "10vh") {
      respuesta.style.height = "0vh";
    } else {
      respuesta.style.height = "10vh";
    }
  }

  contenedorPreguntas = () => {
    const numeroDivs = this.state.guardarIdioma.length / 3;
    let divPosicion = 1;
    let posicionArray = 0;
    for (let i = 0; i < numeroDivs; i++) {
      for (let j = posicionArray; j < this.state.guardarIdioma.length; j++) {
        if (divPosicion <= numeroDivs) {
          const divContenedor = document.getElementById(divPosicion);
          if (divContenedor.children.length < 3) {
            const pregunta = document.createElement("div");
            pregunta.innerHTML = this.state.guardarIdioma[j].pregunta;
            pregunta.style.color = "#fff";
            pregunta.className = "content-preguntas-contenedor";
            pregunta.id = "pregunta-" + j;
            divContenedor.appendChild(pregunta);

            const pregutnaContenedor = document.getElementById("pregunta-" + j);

            // RESPUESTA================================================
            const divRespuesta = document.createElement("div");
            divRespuesta.className = "contenedor-respuesta";
            divRespuesta.id = "respuesta-" + j;
            divRespuesta.innerHTML = this.state.guardarIdioma[j].respuesta;
            pregutnaContenedor.appendChild(divRespuesta);

            //BOTON=================================================
            const boton = document.createElement("div");
            boton.id = "content-preguntas-contenedor-" + j;
            boton.addEventListener("click", () => this.abrirRespuesta(j));
            pregutnaContenedor.appendChild(boton);

            const botonContenedor = document.getElementById(
              "content-preguntas-contenedor-" + j
            );
            const divContent = document.createElement("div");
            divContent.id = "content-preguntas" + j;
            divContent.className = "content-preguntas";
            botonContenedor.appendChild(divContent);

            const div2Contenedor = document.getElementById(
              "content-preguntas" + j
            );
            const span = document.createElement("span");
            span.className = "revelar";
            if (this.state.guardarNuevoIdioma) {
              span.innerHTML = "revelar &nbsp; &#x1f783;";
            } else {
              span.innerHTML = "reveal &nbsp; &#x1f783;";
            }
            div2Contenedor.appendChild(span);
          } else {
            posicionArray = j;
            break;
          }
        }
      }
      divPosicion = divPosicion + 1;
    }
  };

  render() {
    const openNav = () => {
      ReactGA.event({
        category: "Button",
        action: "Se ha dado click en el apartado del nav",
      });
      this.setState({ statusMenu: true });
      const x = window.matchMedia("(max-width: 999px)");
      if (x.matches === true) {
        document.getElementById("myNav").style.height = "110%";
      } else {
        document.getElementById("myNav").style.height = "100%";
      }
      document.getElementById("myNav").style.overflowY = "auto";
      document.getElementsByTagName("html")[0].style.overflowY = "hidden";
    };

    const closeNav = () => {
      this.setState({ statusMenu: false });
      document.getElementsByTagName("html")[0].style.overflowY = "visible";
      document.getElementById("myNav").style.height = "0%";
    };

    const cambiarIdioma = () => {
      if (this.state.guardarNuevoIdioma) {
        this.setState({ guardarIdioma: PreguntasEN });
        this.setState({ guardarNuevoIdioma: false });
        this.setState({ componente: "frequently asked questions" });
        $("#1").empty();
        $("#2").empty();
        $("#3").empty();
        localStorage.setItem("español", true);
        document.getElementById("text-lang").innerHTML = "ENG";
        setTimeout(function () {
          reCharge();
        }, 200);
      } else {
        this.setState({ guardarIdioma: PreguntasF });
        this.setState({ guardarNuevoIdioma: true });
        this.setState({ componente: "preguntas frecuentes" });
        $("#1").empty();
        $("#2").empty();
        $("#3").empty();
        localStorage.setItem("español", false);
        document.getElementById("text-lang").innerHTML = "ESP";
        setTimeout(function () {
          reCharge();
        }, 200);
      }
    };

    const reCharge = () => {
      this.contenedorPreguntas();
    };

    return (
      <Fragment>
        <div className="preguntas-fondo">
          <NavBarComponent
            closeNav={closeNav}
            openNav={openNav}
            statusMenu={this.state.statusMenu}
            cambiarIdioma={cambiarIdioma}></NavBarComponent>
          <MenuComponent
            closeNav={closeNav}
            cambiarIdioma={this.state.guardarNuevoIdioma}
          ></MenuComponent>
          <div className="encabezado-preguntas">
            <EncabezadoComponent
              componente={this.state.componente}
              select={false}
            ></EncabezadoComponent>
          </div>
          <PreguntasComponent
            guardarNuevoIdioma={this.state.guardarNuevoIdioma}
            array={this.state.guardarIdioma}
          ></PreguntasComponent>
          <RedesComponent></RedesComponent>
        </div>
      </Fragment>
    );
  }
}

export default Preguntas;
